import React from "react";

function IconWhatIsACMA() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 2A.75.75 0 013 1.25h11a.75.75 0 01.53.22l3 3c.141.14.22.331.22.53v13a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75V2zm1.5.75v14.5h12.5V5.31l-2.56-2.56H3.75z"
      />
      <path d="M7 8.45h1.588c.035-.663.48-1.09 1.154-1.09.668 0 1.113.404 1.113.96 0 .557-.228.844-.984 1.295-.809.475-1.13 1.002-1.055 1.922l.012.34h1.553v-.31c0-.575.217-.862.996-1.313.826-.486 1.254-1.102 1.254-1.986C12.63 6.932 11.523 6 9.848 6 8.048 6 7.029 7.008 7 8.45zM9.666 14.7c.656 0 1.06-.375 1.06-.978 0-.61-.404-.985-1.06-.985s-1.066.375-1.066.985c0 .603.41.978 1.066.978z" />
    </svg>
  );
}

export default IconWhatIsACMA;
